/**
 * Formatta byte in stringa leggibile (KB/MB/GB).
 * @param {number} bytes
 * @param {{ zeroLabel?: string, unitNames?: string[] }} [opts]
 */
export function formatBytes(bytes, { zeroLabel = '0 B', unitNames = ['B', 'KB', 'MB', 'GB'] } = {}) {
  const n = Number(bytes) || 0;
  if (n === 0) return zeroLabel;
  const k = 1024;
  const i = Math.min(
    unitNames.length - 1,
    Math.floor(Math.log(n) / Math.log(k)),
  );
  return `${parseFloat((n / k ** i).toFixed(2))} ${unitNames[i]}`;
}
